import customaxios from ".";

export const getUserProfileDetails = () => {
  return customaxios({
    method: "GET",
    url: "/user/profile",
  });
};

export const uploadUserPhoto = (data: any) => {
  return customaxios({
    method: "POST",
    url: "/user/profile/photo",
    data,
  });
};

export const deleteUserPhoto = () => {
  return customaxios({
    method: "DELETE",
    url: "/user/profile/photo",
  });
};

export const createUserProfile = (data: any) => {
  return customaxios({
    method: "POST",
    url: "/user/profile",
    data,
  });
};

export const updateUserProfile = (data: any) => {
 return customaxios({
    method: "PUT",
    url: "/user/profile",
    data,
  });
};
export const updateUserProfileFuneralDirector = (data: any) => {
 return customaxios({
    method: "PUT",
    url: "/user/profile/funeral-director",
    data,
  });
};
